import ResendCode from './ResendCode';

export default ResendCode;
